import { mapPrefixes, } from './relationship'
import { categories, } from '@/utils/challenge/relationship-exception'
import { parsePeriodsData, defaultPeriods, } from '@/utils/challenge/relationship-periods'
import _ from 'lodash/string'

const createRelationshipDetails = (prefix) => ([
  {
    label: `${_.startCase(prefix)} Entity`,
    type: 'STRING',
    fieldId: 'RR_END_NODE_ID',
    inline: true,
    jsonPath: `$.${prefix}.info.parentEntity`,
    text: `The LEI code of the ${_.startCase(prefix)}.`,
    autocompleteEntity: true,
  },
  {
    label: 'Relationship Type',
    type: 'STRING',
    fieldId: 'RR_RELATIONSHIP_TYPE',
    // getValue: getRelationshipTypePretty,
    jsonPath: `$.${prefix}.info.type`,
    text: 'The specific category of a directional relationship between two legal entities.',
  },
  {
    label: 'Relationship Periods',
    type: 'RESOURCE',
    fieldId: 'RR_RELATIONSHIP_PERIODS',
    jsonPath: `$.${prefix}.info.periods`,
    multiple: true,
    isPeriod: true,
  },
  {
    label: 'Status',
    fieldId: 'RR_RELATIONSHIP_STATUS',
    type: 'ENUM',
    inline: true,
    jsonPath: `$.${prefix}.info.status`,
    text: 'The status of the relationship.',
    isStatus: true,
  },

  /*
    Tim Sterker
    this one is a special case.. if you check out the xpath,
    it is actually referring to a very specific field and thus
    I'm not sure if and how this should be challenged
    maybe that's a question for the stakeholders, first of all
    https://gleif-cc.slack.com/archives/GLSEP94G4/p1573733086204000

    type: 'STRING' for now
  */
  {
    label: 'Accounting Standard',
    type: 'STRING',
    detailModal: false,
    inline: true,
    fieldId: 'RR_RELATIONSHIP_ACCOUNTING_STANDARD',
    jsonPath: `$.${prefix}.info.accountingStandard`,
    text: 'The relevant accounting standard applicable to the parent entity.',
  },
])

const types = {
  'IS_DIRECTLY_CONSOLIDATED_BY': 'Direct Parent Relationship (Accounting Consolidation)',
  'IS_ULTIMATELY_CONSOLIDATED_BY': 'Ultimate Parent Relationship (Accounting Consolidation)',
  'IS_FUND-MANAGED_BY': 'Fund Management Relationship',
  'IS_SUBFUND_OF': 'Umbrella Fund Relationship',
  'IS_FEEDER_TO': 'Fund Manager Relationship',
  'IS_INTERNATIONAL_BRANCH_OF': 'Head Office Relationship',
}

export const parseRelationshipDetails = ({ type, periods, status, }, prefix) => {
  const parentType = type === 'IS_DIRECTLY_CONSOLIDATED_BY' ? 'directParent' : 'ultimateParent'

  const createField = (prop, value, type = 'info') => ({
    value: value,
    jsonPath: `$.${prefix || parentType}.${type}.${prop}`,
  })

  return [
    createField('type', types[type]),
    createField('periods', parsePeriodsData(periods, prefix)),
    createField('status', status),
    createField('accountingStandard', null),
  ]
}

export const parseRelationshipDetailsForChallenge =
  ({ type, periods, status, parentEntity, reason, category, reference, }, parentType) => {
    const parsedPeriods = periods ? parsePeriodsData(periods, parentType) : defaultPeriods(parentType)
    const createField = (prop, value, type, filedType) => ({
      value: value,
      jsonPath: `$.${parentType}.${type}.${prop}`,
      type: filedType,
      masterField: prop,
    })

    const isParent = (parentType === 'directParent' || parentType === 'ultimateParent')

    const exceptionField = isParent ?
      [
        {
          ...createField('reason', reason, 'exception', 'exception'),

        },
        createField('reference', reference, 'exception', 'exception'),
      ] : []

    const accountingStandardField = isParent ?
      [ createField('accountingStandard', null, 'info', 'parent'), ] : [ ]

    return [
      {
        ...createField('parentEntity', parentEntity, 'info', 'parent'),
        label: 'Parent Entity',
      },
      createField('type', category ? categories[category] : types[type], category ? 'exception' : 'info', 'parent'),
      createField('status', status, 'info', 'parent'),
      ...accountingStandardField,
      ...exceptionField,
      createField('periods', parsedPeriods, 'info', 'parent'),
    ]
  }


export default mapPrefixes(createRelationshipDetails)



// WEBPACK FOOTER //
// ./src/utils/challenge/relationship-details.js